import { dataService } from '../../data';

import { DataObject, ObjectOptions, RelatedObject } from "../base";
import { CreateObject } from "../item";
import { Rasppi } from './rasppi';

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { RasppiType } from '../types';
import { PrinterProductType } from '../types';

const _schema = {
    "name": "PRINTER",
    "fields": [
        { name: "rasppi", type: "objid" },
        { name: "status", type: "string", "default": "AC" },
        { name: "name", type: "string" },
        { name: "device", type: "string" },
        { name: "type", type: "string" },
        { name: "mt", type: "number", "default": "0" },
        { name: "mr", type: "number", "default": "0" },
        { name: "mb", type: "number", "default": "0" },
        { name: "ml", type: "number", "default": "0" },
        { name: "width", type: "number" },
        { name: "font", type: "number" },
        { name: "updates", type: "boolean" },
        { name: "posudts", type: "boolean" },
        { name: "oncash", type: "boolean" },
        { name: "oncard", type: "boolean" },
        { name: "copies", type: "number", "default": "1" },
        { name: "bold", type: "boolean" },
        { name: "style", type: "string", "default": "NULL" }
    ],
    relate: [
        { direction: ">", target: "RASPPI", by: "printers", name: "rasppi", reason: "rasppi", child: false, class: RasppiType },
        { direction: "<", target: "PRINTERPRODUCT", by: "printer", name: "product", reason: "products", child: true, class: PrinterProductType },
    ]
} as const;

const _PrinterClass = CreateObject(_schema);
if (!_PrinterClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class PrintDevice extends _PrinterClass { 
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): PrintDevice {
        return this._Copy(store) as PrintDevice;
    }

    /** Changelog rows lack parent 1:N lists; register on link (see Preselect / TicketProduct). */
    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf || !this.Commited){
            return;
        }

        if (relation === 'printers' && related instanceof Rasppi){
            if (related === this.rasppi){
                related.AddPrinter(this);
            }
        }
    }

    get status(): string | null {
        return this['__base__status'];
    }

    set status(value: string){
        if (this.status == 'DE'){
            return;     // cannot modify deleted items
        }

        if (this.status == value){
            return;
        }

        this['__base__status'] = value;
        if (this.rasppi){
            if ((this.status == 'DE') && !this.Commited){
                this.rasppi.DelPrinter(this);
            }
            else {
                this.rasppi.DoRefresh(this.table);
            }
        }
    }

    get IsValid(): boolean {
        return (!!this.status && (this.status != 'DE'));
    }
}

